import * as React from 'react';
import classNames from 'classnames';

import useToggle from '../hooks/use-toggle';
import useClickOutside from '../hooks/use-click-outside';
import useEscape from '../hooks/use-escape';
import { useIsMounted } from '../hooks/use-is-mounted';
import FormContent from '../form-content';
import ChevronUp from '../icons/24/arrow-up';
import ChevronDown from '../icons/24/arrow-down';
import Text from '../text';

import { Filter as Props } from './filter.types';

const Filter: React.FunctionComponent<Props> = ({
  formContentOptions,
  selectedOptionsCount,
  testTags,
  title,
}) => {
  const isMounted = useIsMounted();
  const modal = React.useRef(null);
  const [isOpen, toggle, , close] = useToggle(false);

  useClickOutside(modal, close);
  useEscape(close);

  return (
    <div
      className={classNames('filter', {
        'filter--clicked': isOpen,
      })}
      ref={modal}
      {...testTags}
    >
      {isMounted ? (
        <div className="filter__buttons">
          <button
            type="button"
            className="filter__button"
            onClick={toggle}
            data-test-dropdown-button
          >
            <Text
              size={Text.sizes.basic}
              theme={Text.themes.emphasis}
              className="filter__button-text"
            >
              {title}
            </Text>

            <div className="filter__button-inner-right">
              {selectedOptionsCount ? (
                <Text
                  className="filter__selected-options"
                  theme={Text.themes.emphasis}
                  size={Text.sizes.small}
                >
                  {selectedOptionsCount}
                </Text>
              ) : null}

              {isOpen ? <ChevronUp /> : <ChevronDown />}
            </div>
          </button>
        </div>
      ) : (
        <div className="filter__loading-button">
          <div className="filter__loading-placeholder">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="112"
              height="22"
              viewBox="0 0 112 22"
              fill="none"
            >
              <path
                d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5H108C110.209 0.5 112 2.29086 112 4.5V17.5C112 19.7091 110.209 21.5 108 21.5H4C1.79086 21.5 0 19.7091 0 17.5V4.5Z"
                fill="#DCDEE0"
              />
            </svg>
          </div>
          <div className="filter__loading-icon">
            <ChevronDown />
          </div>
        </div>
      )}

      <FormContent
        {...formContentOptions}
        isOpen={isOpen}
        close={close}
        onSubmit={toggle}
      />
    </div>
  );
};

export default Filter;
